import {t,useLanguage} from '../i18n';
import React, {useEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';
export default function MobileNavigation({children}) {
 useLanguage();
  const ref=useRef(null);
  const [hidden,setHidden]=useState(false);
  useEffect(()=>{
    const viewport=window.visualViewport;
    let baseline=window.innerHeight;
    const update=()=>{
      const focused=document.activeElement;
      const editing=focused?.matches?.('input,textarea,[contenteditable="true"]');
      const keyboard=Boolean(editing && viewport && baseline-viewport.height>120);
      const dialog=[...document.querySelectorAll('[aria-modal="true"],dialog[open]')].some(el=>el.getClientRects().length>0);
      setHidden(keyboard||dialog);
    };
    const orientation=()=>{baseline=window.innerHeight;update();};
    const observer=new MutationObserver(update);
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-modal','open','hidden']});
    viewport?.addEventListener('resize',update);
    window.addEventListener('orientationchange',orientation);
    document.addEventListener('focusin',update);document.addEventListener('focusout',update);
    update();
    return ()=>{observer.disconnect();viewport?.removeEventListener('resize',update);window.removeEventListener('orientationchange',orientation);document.removeEventListener('focusin',update);document.removeEventListener('focusout',update);};
  },[]);
  useEffect(()=>{
    const root=document.documentElement;
    const previous=root.style.getPropertyValue('--loop-bottom-navigation-height');
    const measure=()=>root.style.setProperty('--loop-bottom-navigation-height',hidden?'0px':`${ref.current?.getBoundingClientRect().height||0}px`);
    const observer=typeof ResizeObserver === "function" ? new ResizeObserver(measure) : null;if(ref.current)observer?.observe(ref.current);window.addEventListener("resize",measure);measure();
    document.body.classList.add('loop-has-bottom-navigation');
    return ()=>{observer?.disconnect();window.removeEventListener("resize",measure);document.body.classList.remove('loop-has-bottom-navigation');root.style.setProperty('--loop-bottom-navigation-height',previous);};
  },[hidden]);
  return createPortal(<nav ref={ref} hidden={hidden} className="loop-premium-mobile-nav" aria-label={t("Accesos principales")}>{children}</nav>,document.body);
}
